import { PromptTemplateCategory } from '../types';

export const professional: PromptTemplateCategory = {
  title: "プロフェッショナル",
  icon: "💼",
  templates: [
    {
      title: "YouTube / 動画スクリプト",
      content: `一人のナレーターによるYouTube動画のスクリプトを書いてください。
- 動画のトピックは[在宅勤務でよくある5つの間違い — そしてその直し方]です。
- ターゲット視聴者：[初めてのリモートワークを始める若手プロフェッショナル]。
- トーン：[フレンドリーで、会話的で、実用的 — 信頼できる同僚からのアドバイスのように]。
- 最初の2文に強いフック、ポイント間の明確なトランジション、行動喚起を含む簡潔なクロージングで構成してください。
- 話す用に書いてください：短い段落や修辞的な質問を使ってリスナーの注意を維持してください。`
    },
    {
      title: "製品紹介",
      content: `製品紹介動画のナレーションスクリプトを書いてください。
- 製品は[領収書をスキャンして経費を追跡する中小企業オーナー向けモバイルアプリ]です。
- ターゲット視聴者：[経理が嫌いなフリーランサーや中小企業オーナー]。
- 強調すべき主なメリット：
  1. [2秒で領収書をスキャン — 手入力不要]。
  2. [スマートな提案による自動経費カテゴリ分類]。
  3. [確定申告シーズンに向けたワンタップ書き出し]。
- トーン：[明確で、明るく、安心感がある — 面倒な作業を簡単にする]。
- 文は簡潔でパンチのあるものにしてください。専門用語は避けてください。`
    },
    {
      title: "プレゼンテーションスピーチ",
      content: `プロフェッショナルなプレゼンテーションまたは基調講演のスピーチを書いてください。
- 場面は[新しい四半期のキックオフとなる全社集会]です。
- 話し手は[エンジニア、デザイナー、マネージャーが混在する聴衆に向けて話すチームリーダー]です。
- 核心メッセージ：[前四半期の成果を称え、課題を正直に認め、今後数ヶ月の明確な方針の下にチームを結集させる]。
- トーン：[自信に満ち、誠実で、やる気を引き出す — 企業的な紋切り型ではなく]。
- 話す時間の目安：[4分]。
- 会話的な表現、戦略的な間、心に残る締めの言葉を使ってください。`
    }
  ]
};
